import React from 'react';

import JumboHeader from './components/JumboHeader';
import AppsGrid from './components/AppsGrid';
import AppDirNavHeader from '../../components/AppDirNavHeader';
import AppDirectoryBasePage from '../AppDirectoryBasePage';

const Home = () => {
  return (
    <div data-testid="Home__AppsDirectory">
      <AppDirectoryBasePage
        id="App Directory - Home"
        header={
          <>
            <AppDirNavHeader />
            <JumboHeader />
          </>
        }
      >
        <AppsGrid gridOption="FEATURED" />
        <div className="wds-m-t-4">
          <AppsGrid gridOption="MOST_POPULAR" />
        </div>
        <div className="wds-m-t-4">
          <AppsGrid gridOption="RECENTLY_ADDED" />
        </div>
      </AppDirectoryBasePage>
    </div>
  );
};

export default Home;
